import { render, staticRenderFns } from "./context-menu.vue?vue&type=template&id=6c84b178&"
import script from "./context-menu.vue?vue&type=script&lang=js&"
export * from "./context-menu.vue?vue&type=script&lang=js&"
import style0 from "./context-menu.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports